import React, { useEffect } from 'react';
import { useEvents } from '../events/useEvents';
import ProfileCourses from './ProfileCourses';
import { useDispatch } from 'react-redux';
import { fetchEvents } from '../../redux-actions/actionsEvents';

const LayerViewProfileCourses: React.FC = () => {
  const { upcomingEventsSorted, pastEventsSorted } = useEvents();
  const dispatch = useDispatch();

  const handleOnToggleAttend = () => {
    dispatch(fetchEvents());
  };

  useEffect(() => {
    dispatch(fetchEvents());
  }, [dispatch]);

  return (
    <ProfileCourses
      upcomingEventsSorted={upcomingEventsSorted}
      pastEventsSorted={pastEventsSorted}
      onToggleAttend={handleOnToggleAttend}
    />
  );
};

export default LayerViewProfileCourses;
